import { Enumeration } from '@bp/shared/models/core/enum';

export class SlidingStepRoute extends Enumeration {

}
